import React, { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import Accordion from "../../components/Accordion/Accordion";
import TextInput from "../../components/TextInput";
import { ScreenContext } from "../../contexts/ScreenContext";
import ProductController from "../../controllers/ProductController";
import styles from "./CreateProductAccordion.module.css";

const CreateProductLTCCosts = ({
  isNew,
  p,
  errors,
  onPropertyChange,
  onError,
  onAddImage,
  onDeleteImage,
}) => {
  const { t } = useTranslation("createProductCosts");
  const productControllerRef = useRef(null);

  const { smallScreen } = useContext(ScreenContext);
  const smScreen = useMediaQuery(smallScreen);

  useEffect(() => {
    productControllerRef.current = new ProductController();
  }, []);

  return (
    <Accordion title={t("tabLtc")}>
      <div
        className={
          smScreen
            ? styles.CreateProductAccordion__col
            : styles.CreateProductAccordion__row
        }
      >
        <div className={styles.CreateProductAccordion__col}>
          <TextInput
            type={"number"}
            labelName={t("awpBulkLabel")}
            isEnabled={true}
            value={p?.ltcAwpBulk || ""}
            validationText={t(errors.ltcAwpBulk, { ns: "validation" })}
            focus={false}
            onChange={(val) => {
              onPropertyChange({ ltcAwpBulk: parseFloat(val) });
            }}
          />
        </div>
        <div className={styles.CreateProductAccordion__col}>
          <TextInput
            type={"number"}
            labelName={t("awpItemLabel")}
            isEnabled={true}
            value={p?.ltcAwpItem || ""}
            validationText={t(errors.ltcAwpItem, { ns: "validation" })}
            focus={false}
            onChange={(val) => {
              onPropertyChange({ ltcAwpItem: parseFloat(val) });
            }}
          />
        </div>
      </div>
    </Accordion>
  );
};

export default CreateProductLTCCosts;
